<template>
  <v-container>
    <v-layout>
      <v-container>
        <v-card>
          <v-toolbar
            card
            color="#0C116F">
            <v-toolbar-title class="white--text">Import Entities from CSV</v-toolbar-title>
          </v-toolbar>

          <v-card-text>

            <v-form enctype="multipart/form-data">

              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
              <v-btn @click="submit" color="error">Import Entities</v-btn>
              <v-btn @click="cancel">Cancel</v-btn>

            </v-form>

            <v-divider class="my-2"></v-divider>

            <div>
              <p>
                Requirements for the CSV file for new entities with new fulltext search:
              </p>
              <ul>
                <li>Tab separated (<code>\t</code>) values</li>
                <li>
                  Field Names:
                  <ul>                 
                    <li><code>Entity_Name</code> (REQUIRED)</li>
                    <li><code>Search_Query</code> (REQUIRED)</li>
                    <li><code>Country_Code</code> (comma separated list of country codes for the entity; currently DE, IT, AT, CH, EN, FR) (REQUIRED)</li>    
                    <li><code>language_code</code> (comma separated list of languages for the fulltext search e.g. <code>DE,IT</code>) (REQUIRED)</li>                                                                                             
                    <li><code>Tags</code> (comma separated list of tags e.g. <code>TOP5000,DAX</code>)</li>
                    <li><code>Searchname</code> (Name of fulltext search; if not set the entity name is used)</li>
                    <li><code>Ubermetrics_Search_Query</code> (If set, this will be used as search query when creating a new Fulltext Search. Otherwise <code>Search_Query</code> is used)</li>
                    <li><code>Author_Query</code> (if you want to filter for specific authors)</li>
                    <li><code>Industry_1</code> (Name of Industry_1 for entity)</li> 
                    <li><code>Industry_2</code> (Name of Industry_2 for entity)</li>
                    <li><code>Industry_Final</code> (Name of Industry_Final for entity)</li>
                    <li><code>Industries_Austria</code> (comma separated list of austrian industries for entity)</li>  
                    <li><code>Industries_Switzerland</code> (NOT an array! name of industry for ch)</li>     
                    <li><code>Kununu_Links</code> (comma separated list of kununu links)</li>                                                          
                    <li><code>Twitter_Authors</code> (comma separated list of twitter authors)</li>  
                    <li><code>backward_search</code> (Boolean value: True or False)</li>                                                                                                                                                                                                                                                                                                                                
                  </ul>
                </li>
              </ul>
              <p>
                <br><br>Requirements for the CSV file for new entities with existing fulltext search(es):
              </p>
              <ul>
                <li>Tab separated (<code>\t</code>) values</li>
                <li>
                  Field Names:
                  <ul>                 
                    <li><code>Entity_Name</code> (REQUIRED)</li>
                    <li><code>Search_Query</code> (REQUIRED)</li>
                    <li><code>Country_Code</code> (comma separated list of country codes for the entity; currently DE, IT, AT, CH, EN, FR) (REQUIRED)</li>    
                    <li><code>Account_Search_Ids</code> (comma separated list of account_search_ids e.g. <code>1_1,2_2</code>) (REQUIRED)</li>                                                                                             
                    <li><code>Tags</code> (comma separated list of tags e.g. <code>TOP5000,DAX</code>)</li>
                    <li><code>Industry_1</code> (Name of Industry_1 for entity)</li> 
                    <li><code>Industry_2</code> (Name of Industry_2 for entity)</li>
                    <li><code>Industry_Final</code> (Name of Industry_Final for entity)</li>
                    <li><code>Industries_Austria</code> (comma separated list of austrian industries for entity)</li>     
                    <li><code>Industries_Switzerland</code> (NOT an array! name of industry for ch)</li> 
                    <li><code>Kununu_Links</code> (comma separated list of kununu links)</li>                                                          
                    <li><code>Twitter_Authors</code> (comma separated list of twitter authors)</li>                                                                                                                                      
                  </ul>
                </li>
              </ul>              
              <p>
                <br><br>Requirements for the CSV file to update existing entities DONT USE THIS until it has been reviewed!:
              </p>
              <ul>
                <li>Tab separated (<code>\t</code>) values</li>
                <li>
                  Field Names:
                  <ul>
                    <li><code>Uuid</code> (REQUIRED)</li>
                    <li><code>Entity_Name</code></li>
                    <li><code>Tags</code> (comma separated list of tags e.g. <code>TOP5000,DAX</code>)</li>
                    <li><code>Ubermetrics_Account_Id</code></li>
                    <li><code>Ubermetrics_Search_Id</code></li>
                    <li><code>Searchname</code> (Name of search in Ubermetrics)</li>
                    <li><code>Search_Query</code></li>
                    <li><code>Ubermetrics_Search_Query</code> (If set, this will be used as search query when creating a new Ubermetrics Search. Otherwise <code>Search_Query</code> is used)</li>
                    <li><code>Author_Query</code> (if you want to filter for specific authors)</li>
                    <li><code>Search_Type</code> (Einzelsuche/SINGLE_SEARCH or Branchensuche/MULTI_SEARCH)</li>
                    <li><code>Country_Code</code> (currently DE, IT, AT, DE_AT)</li>
                    <li><code>Industry_1</code> (Name of Industry_1 for entity)</li> 
                    <li><code>Industry_2</code> (Name of Industry_2 for entity)</li>
                    <li><code>Industry_Final</code> (Name of Industry_Final for entity)</li>
                  </ul>
                </li>
              </ul>
              <p>
                <br><br>Additional hints:
              </p>
              <ul>
                <li>The entity import can handle mixed csvs, i.e. adding new and updating existing entities at the same time</li>
                <li>The field names are CASE SENSITIVE!!!</li>
                <li>The success messages are misleading. After the import, please check directly in the step function, if everything worked.</li>
                <li>To check: Does update entities with tags add them or overwrite them?</li>
                <li>Please note: Tags, Industries and Country Codes are hard coded. If you add a completely new one, it wont appear in the app. You have to add it to the gui first.</li>
              </ul>
            </div>

          </v-card-text>
          <v-snackbar
            v-model="snackbar"
            :multi-line="true"
            :timeout="6000"
            :top="true"
            :vertical="true"
          >
            {{ text }}
            <v-btn
              color="pink"
              flat
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>

        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import Config from '../utils/Config';
  import AmplifyStore from '../store/store';

  export default {
    data() {
      return {
        file: null,
        snackbar: false,
      };
    },
    mounted() {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken;
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      'cancel': function() {
        this.$router.go(-1);
      },
      'submit': function() {

        this.$emit('TriggerLoading', true);

        let formData = new FormData();
        formData.append('file', this.file);
        axios.post(`${Config.API_URL}/entity/import`, this.file, {
          headers: {
            'Content-Type': `multipart/form-data`,
          },
        }).then(response => {
          this.text = response.data.message;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);
          console.info(response.data);
        }).catch(error => {
          this.text = error.response.data.message;
          this.errored = true;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);
        });
      },
    },
  };
</script>
